const basicMapper = array => array.map(c => ({ value: c.uuid, label: c.name || c.full_name }));
const simpleMapper = array => array.map(c => ({ value: c, label: c }));

export const optionsMappers = {
  companies: basicMapper,
  services: basicMapper,
  team_leads: basicMapper,
  opening_team_leads: resp => basicMapper(resp.results),
  jobs_statuses: simpleMapper,
  recruiters: basicMapper,
  openings_statuses: simpleMapper,
  offices: basicMapper,
  experience_levels: array =>
    array.map(c =>
      c.level === 'Custom' ? { value: c.custom_level, label: c.custom_level } : { value: c.level, label: c.level }
    ),
};

export const searchFiltersMapper = ({ search: _s, promotion_applied: _promotionApplied, ...filters }) =>
  Object.fromEntries(Object.entries(filters).map(([k, v]) => [k, v.map(val => val.value)]));
